/* ============================================================
   California Leaf — Mejora de las cards del widget Searchanise
   Inyecta en cada card del widget (li.snize-product):
   - Badges de sustancia / nivel (metafields, vía ?view=cl-meta)
   - Badge de % de descuento (calculado de los precios)
   - Fila de cashback (5% del precio)
   - Acciones: carrito circular (AJAX) + botón Comprar
   Los estilos viven en searchanise-theme-cards.css
   ============================================================ */
(function () {
  'use strict';

  var CASHBACK_RATE = 0.05;
  var CASHBACK_ICON =
    'https://cdn.shopify.com/s/files/1/0628/9129/4783/files/icono_moneda.png?v=1781292762';
  var META_VIEW = 'cl-meta';

  /* ---------- utilidades ---------- */

  function parsePrice(el) {
    if (!el) return 0;
    var t = (el.textContent || '').replace(/[^\d.,]/g, '');
    if (!t) return 0;
    // formato tienda: $1,234.56 → quitar comas de miles
    t = t.replace(/,/g, '');
    var n = parseFloat(t);
    return isNaN(n) ? 0 : n;
  }

  function formatMoneyInt(n) {
    return '$' + Math.floor(n).toLocaleString('en-US');
  }

  function productHandle(url) {
    var m = (url || '').match(/\/products\/([a-z0-9-_]+)/i);
    return m ? m[1] : null;
  }

  /* ---------- metafields (sustancia / nivel) ---------- */

  var metaCache = {};

  function getMeta(handle) {
    if (!handle) return Promise.resolve(null);
    if (metaCache[handle]) return metaCache[handle];
    var stored = null;
    try {
      stored = sessionStorage.getItem('clmeta3:' + handle);
    } catch (e) {}
    if (stored) {
      var parsed = null;
      try {
        parsed = JSON.parse(stored);
      } catch (e) {}
      metaCache[handle] = Promise.resolve(parsed);
      return metaCache[handle];
    }
    metaCache[handle] = fetch('/products/' + handle + '?view=' + META_VIEW)
      .then(function (r) {
        if (!r.ok) return null;
        return r.text();
      })
      .then(function (text) {
        if (!text) return null;
        var data = null;
        try {
          data = JSON.parse(text);
        } catch (e) {
          return null; // la plantilla cl-meta no existe o devolvió HTML
        }
        try {
          sessionStorage.setItem('clmeta3:' + handle, JSON.stringify(data));
        } catch (e) {}
        return data;
      })
      .catch(function () {
        return null;
      });
    return metaCache[handle];
  }

  /* ---------- carrito (misma lógica que la card del tema) ---------- */

  function refreshCartDrawer() {
    var drawerEl = document.querySelector('cart-drawer');
    fetch('/?sections=cart-drawer')
      .then(function (r) {
        return r.json();
      })
      .then(function (data) {
        if (data['cart-drawer']) {
          var tmp = document.createElement('div');
          tmp.innerHTML = data['cart-drawer'];
          var newInner = tmp.querySelector('cart-drawer');
          if (drawerEl) {
            var sels = [
              '#CartDrawer-CartItems',
              '[id*="CartItems"]',
              '.cart-drawer__contents',
              '.js-cart-items',
              '.cart-drawer__footer',
              '#CartDrawer-Footer',
              '.cart__footer'
            ];
            var matched = false;
            sels.forEach(function (sel) {
              var n = tmp.querySelector(sel);
              var o = drawerEl.querySelector(sel);
              if (n && o) {
                o.innerHTML = n.innerHTML;
                matched = true;
              }
            });
            if (!matched && newInner) drawerEl.innerHTML = newInner.innerHTML;
          } else if (newInner) {
            document.body.insertAdjacentHTML('beforeend', newInner.outerHTML);
            drawerEl = document.querySelector('cart-drawer');
          }
        }
        fetch('/cart.js')
          .then(function (r) {
            return r.json();
          })
          .then(function (cart) {
            document
              .querySelectorAll('.js-cart-count,.cart-count-bubble,[data-cart-count]')
              .forEach(function (el) {
                el.textContent = cart.item_count;
              });
          });
        if (drawerEl && typeof drawerEl.open === 'function') drawerEl.open();
      })
      .catch(function () {
        var drawerEl = document.querySelector('cart-drawer');
        if (drawerEl && typeof drawerEl.open === 'function') drawerEl.open();
      });
  }

  function addToCart(btn) {
    var variantId = btn.getAttribute('data-variant-id');
    var handle = btn.getAttribute('data-handle');
    btn.disabled = true;
    btn.style.opacity = '0.5';

    var variantPromise = variantId
      ? Promise.resolve(parseInt(variantId, 10))
      : fetch('/products/' + handle + '.js')
          .then(function (r) {
            return r.json();
          })
          .then(function (p) {
            var v = null;
            (p.variants || []).some(function (vv) {
              if (vv.available) {
                v = vv.id;
                return true;
              }
              return false;
            });
            return v || (p.variants && p.variants[0] && p.variants[0].id);
          });

    variantPromise
      .then(function (id) {
        if (!id) throw new Error('no variant');
        return fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: id, quantity: 1 })
        });
      })
      .then(function (r) {
        return r.json();
      })
      .then(function () {
        btn.disabled = false;
        btn.style.opacity = '1';
        refreshCartDrawer();
      })
      .catch(function () {
        btn.disabled = false;
        btn.style.opacity = '1';
      });
  }

  /* ---------- mejora de cada card ---------- */

  function buildBadge(cls, text) {
    var s = document.createElement('span');
    s.className = 'cl-badge ' + cls;
    s.textContent = text;
    return s;
  }

  function enhanceCard(li) {
    if (li.classList.contains('cl-snize-done')) return;
    li.classList.add('cl-snize-done');

    var link = li.querySelector('a.snize-view-link');
    var url = link ? link.getAttribute('href') : null;
    var handle = productHandle(url);
    var thumbWrap = li.querySelector('.snize-thumbnail-wrapper');
    var priceEl = li.querySelector('.snize-price');
    var oldEl = li.querySelector('.snize-discounted-price');
    var price = parsePrice(priceEl);
    var compare = parsePrice(oldEl);
    var available = !/out-of-stock/i.test(li.className);

    /* --- badges sobre la imagen --- */
    if (thumbWrap) {
      var badges = document.createElement('div');
      badges.className = 'cl-card-badges';
      var discountBadge = null;
      if (compare > price && price > 0) {
        var pct = Math.round(((compare - price) / compare) * 100);
        if (pct > 0) {
          discountBadge = buildBadge('cl-badge--discount', pct + '%');
          badges.appendChild(discountBadge);
        }
      }
      thumbWrap.appendChild(badges);

      getMeta(handle).then(function (meta) {
        if (!meta) return;
        var ref = badges.firstChild; // los metafields van antes del descuento
        if (meta.nivel) badges.insertBefore(buildBadge('cl-badge--nivel', meta.nivel), ref);
        if (meta.sustancia)
          badges.insertBefore(buildBadge('cl-badge--sustancia', meta.sustancia), badges.firstChild);
      });
    }

    /* --- extras: cashback + acciones (fuera del <a> del widget) --- */
    var extra = document.createElement('div');
    extra.className = 'cl-snize-extra';

    var cashback = Math.floor(price * CASHBACK_RATE);
    if (cashback > 0) {
      var cb = document.createElement('div');
      cb.className = 'cl-card-cashback';
      cb.setAttribute('data-cl-cash', '');
      /* la moneda es un <span> (no <button>) porque va dentro del <a> del widget */
      var coin = document.createElement('span');
      coin.className = 'cl-card-coin';
      coin.setAttribute('role', 'button');
      coin.setAttribute('tabindex', '0');
      coin.setAttribute('aria-label', 'California Cash');
      var icon = document.createElement('img');
      icon.src = CASHBACK_ICON;
      icon.alt = '';
      icon.width = 20;
      icon.height = 20;
      icon.loading = 'lazy';
      coin.appendChild(icon);
      var amount = document.createElement('span');
      amount.className = 'cl-card-cashback__amount';
      amount.textContent = formatMoneyInt(cashback);
      var tip = document.createElement('span');
      tip.className = 'cl-card-tooltip';
      tip.setAttribute('role', 'tooltip');
      tip.textContent = 'California Cash';
      cb.appendChild(coin);
      cb.appendChild(amount);
      cb.appendChild(tip);

      /* Precio + cashback en la misma línea (cashback pegado a la derecha) */
      var priceList = li.querySelector('.snize-price-list');
      if (priceList && priceList.parentNode) {
        var priceline = document.createElement('div');
        priceline.className = 'cl-snize-priceline';
        priceList.parentNode.insertBefore(priceline, priceList);
        priceline.appendChild(priceList);
        priceline.appendChild(cb);
      } else {
        extra.appendChild(cb);
      }
    }

    var actions = document.createElement('div');
    actions.className = 'cl-card-actions';

    var variantId = li.getAttribute('data-product-variant');

    /* Agotado: se OCULTA el carrito (no se renderiza) */
    if (available) {
      var cartBtn = document.createElement('button');
      cartBtn.type = 'button';
      cartBtn.className = 'cl-card-cart';
      cartBtn.setAttribute('aria-label', 'Agregar al carrito');
      cartBtn.title = 'Agregar al carrito';
      if (variantId) cartBtn.setAttribute('data-variant-id', variantId);
      if (handle) cartBtn.setAttribute('data-handle', handle);
      cartBtn.innerHTML =
        '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">' +
        '<circle cx="9" cy="21" r="1"/><circle cx="20" cy="21" r="1"/>' +
        '<path d="M1 1h4l2.68 13.39a2 2 0 001.99 1.61h9.72a2 2 0 001.97-1.67L23 6H6"/></svg>';
      cartBtn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        addToCart(cartBtn);
      });
      actions.appendChild(cartBtn);
    }

    /* Disponible → "Comprar" (lima); agotado → "Ver producto" (outline blanco) */
    var buy = document.createElement('a');
    buy.className = 'cl-card-buy' + (available ? '' : ' cl-card-buy--soldout');
    buy.href = url || '#';
    buy.innerHTML =
      '<span class="cl-card-buy__label">' + (available ? 'Comprar' : 'Ver producto') + '</span>';
    actions.appendChild(buy);

    extra.appendChild(actions);
    li.appendChild(extra);

    /* --- variante: píldora junto al precio + links a la variante ---
       (la app separa variantes como productos; sin esto las cards
       parecen duplicadas y no se sabe cuál es cuál) */
    if (variantId) {
      getMeta(handle).then(function (meta) {
        if (!meta || !meta.has_variants || !meta.variants) return;
        var v = null;
        meta.variants.some(function (x) {
          if (String(x.id) === String(variantId)) {
            v = x;
            return true;
          }
          return false;
        });
        if (!v || !v.title || v.title === 'Default Title') return;

        /* Etiqueta de la variante; si la opción es de piezas se agrega "pz"
           al número (ej. "15" → "15 pz") */
        var label = v.title;
        if (v.opts && meta.option_names) {
          label = v.opts
            .map(function (val, i) {
              var optName = String(meta.option_names[i] || '').toLowerCase();
              var s = String(val).trim();
              if (/pieza|pzas?\b|pz\b/.test(optName) && !/pz|pieza/i.test(s)) {
                return s + ' pz';
              }
              return s;
            })
            .join(' / ');
        }

        /* La píldora va como hija del contenedor de info, arriba del precio
           (el CSS la ordena con order: 4, antes de .snize-price-list) */
        var infoBox = li.querySelector('.snize-overhidden') || li.querySelector('.snize-price-list');
        if (infoBox && !li.querySelector('.cl-variant-badge')) {
          var vb = document.createElement('span');
          vb.className = 'cl-variant-badge';
          vb.textContent = label;
          infoBox.appendChild(vb);
        }

        if (url) {
          var base = url.split('#')[0];
          var urlVariant;
          if (/[?&]variant=/.test(base)) {
            urlVariant = base.replace(/([?&]variant=)[^&]*/, '$1' + variantId);
          } else {
            urlVariant = base + (base.indexOf('?') === -1 ? '?' : '&') + 'variant=' + variantId;
          }
          if (link) link.setAttribute('href', urlVariant);
          var buyLink = li.querySelector('a.cl-card-buy');
          if (buyLink) buyLink.href = urlVariant;
        }
      });
    }
  }

  function dedupeWidgets() {
    /* Si la página trae el widget duplicado (p. ej. el snippet del tema y
       además la sección de la app agregada desde el editor de temas, o un
       contenedor extra del modo redirect), se conserva solo el contenedor
       con contenido real y se ocultan los demás */
    var all = [].slice.call(document.querySelectorAll('[id="snize_results"]'));
    if (all.length > 1) {
      var keep = null;
      all.forEach(function (c) {
        if (!keep && c.querySelector('.snize-main-panel, li.snize-product')) keep = c;
      });
      if (!keep) keep = all[0];
      all.forEach(function (c) {
        if (c !== keep) c.style.display = 'none';
      });
    }
    /* Y si dentro del contenedor visible el encabezado o el panel superior
       aparecen dos veces, se oculta el repetido */
    ['.snize-main-panel', '.snize-search-results-header'].forEach(function (sel) {
      var els = document.querySelectorAll('#snize_results ' + sel);
      for (var i = 1; i < els.length; i++) els[i].style.display = 'none';
    });
  }

  function forceGridMode() {
    /* El selector de vista está oculto por CSS; si el navegador guardó
       el modo lista de una visita anterior, se regresa a cuadrícula */
    var listActive = document.querySelector(
      '.snize-main-panel-view-mode a.active:not(.snize-grid-mode-icon)'
    );
    if (listActive) {
      var grid = document.querySelector('.snize-main-panel-view-mode a.snize-grid-mode-icon');
      if (grid) grid.click();
    }
  }

  /* ---------- lupa del header: panel de la app en un solo clic ----------
     Al abrir el modal de búsqueda del tema se enfoca el input y se disparan
     los eventos que el widget de Searchanise escucha, para que su panel
     aparezca de inmediato sin que el usuario tenga que dar otro clic */
  function openAppSearchPanel() {
    setTimeout(function () {
      var input = document.querySelector(
        '.header__search-inner input[name="q"], .header__search-inner input[type="search"]'
      );
      if (!input) return;
      input.focus();
      ['mousedown', 'mouseup', 'click', 'focus', 'keyup'].forEach(function (type) {
        try {
          input.dispatchEvent(new Event(type, { bubbles: true }));
        } catch (e) {}
      });
    }, 250);
  }

  function bindSearchOpen() {
    document.querySelectorAll('.search-open-btn').forEach(function (btn) {
      if (btn.getAttribute('data-cl-snize-open')) return;
      btn.setAttribute('data-cl-snize-open', '1');
      btn.addEventListener('click', openAppSearchPanel);
      btn.addEventListener('keydown', function (e) {
        if (e.key === 'Enter') openAppSearchPanel();
      });
    });
  }

  function scan() {
    bindSearchOpen();
    dedupeWidgets();
    forceGridMode();
    var cards = document.querySelectorAll('li.snize-product:not(.cl-snize-done)');
    for (var i = 0; i < cards.length; i++) {
      /* Las SUGERENCIAS del autocompletado también usan li.snize-product,
         pero viven en un panel (.snize-ac-results) fuera de .snize donde
         nuestro CSS no aplica — inyectarles extras ahí sacaba la moneda
         del cashback a tamaño natural (gigante). Se quedan con el layout
         compacto nativo del widget. */
      if (cards[i].closest('.snize-ac-results, .snize-ac-results-mobile')) continue;
      enhanceCard(cards[i]);
    }
  }

  /* ---------- observador: el widget renderiza y re-renderiza tarde ---------- */

  var scanScheduled = false;
  function scheduleScan() {
    if (scanScheduled) return;
    scanScheduled = true;
    setTimeout(function () {
      scanScheduled = false;
      scan();
    }, 100);
  }

  /* Tooltip de cashback: tap en mobile (una sola vez, compartido con la
     card del tema vía window.clCardCashInit) */
  function bindCashTooltip() {
    if (window.clCardCashInit) return;
    window.clCardCashInit = true;
    document.addEventListener('click', function (e) {
      var coin = e.target.closest('.cl-card-coin');
      if (coin && window.matchMedia('(hover: none)').matches) {
        e.preventDefault();
        var cash = coin.closest('.cl-card-cashback');
        var open = cash.classList.toggle('cl-card-cashback--open');
        if (open) {
          document.querySelectorAll('.cl-card-cashback--open').forEach(function (c) {
            if (c !== cash) c.classList.remove('cl-card-cashback--open');
          });
        }
        return;
      }
      if (!e.target.closest('.cl-card-cashback')) {
        document.querySelectorAll('.cl-card-cashback--open').forEach(function (c) {
          c.classList.remove('cl-card-cashback--open');
        });
      }
    });
  }

  function init() {
    scan();
    bindCashTooltip();
    var observer = new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        if (mutations[i].addedNodes.length) {
          scheduleScan();
          return;
        }
      }
    });
    observer.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
